// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"idt-expandablescrollcontainer_buttoncontainer__3mhvz","buttonIcon":"idt-expandablescrollcontainer_buttonicon__4-44x"};